// Contesto del negozio personale (modalità negozio). Fuori dal negozio vale null:
// i componenti condivisi (es. la scheda prodotto) lo usano per sapere dove si trovano.
import { createContext, useContext } from 'react';

export const ShopContext = createContext(null);

export const useShop = () => useContext(ShopContext);
